import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Indicare il periodo di riferimento per la generazione delle fatture. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Se necessario è possibile indicare anche una città. ")
], -1)
const _hoisted_2 = { class: "p-d-flex pi-ai-center" }
const _hoisted_3 = { class: "p-mr-5" }
const _hoisted_4 = { class: "p-ml-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_ZoneAutocomplete = _resolveComponent("ZoneAutocomplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    class: "p-mb-3",
    header: _ctx.$t('billing_customers.params.title'),
    toggleable: true,
    collapsed: false
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.dateRange,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.dateRange = $event)),
            manualInput: false,
            selectionMode: "range",
            showIcon: true
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_FloatLabel, {
          label: "Città",
          class: "p-fluid"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ZoneAutocomplete, {
              modelValue: _ctx.zone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.zone = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            label: "Cerca",
            icon: "pi pi-search",
            loading: _ctx.isLoading,
            onClick: _ctx.submit
          }, null, 8, ["loading", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["header"]))
}